import { render, staticRenderFns } from "./warehouse-add-inventory-material-modal.vue?vue&type=template&id=63f5b461&scoped=true"
import script from "./warehouse-add-inventory-material-modal.vue?vue&type=script&lang=js"
export * from "./warehouse-add-inventory-material-modal.vue?vue&type=script&lang=js"
import style0 from "./warehouse-add-inventory-material-modal.vue?vue&type=style&index=0&id=63f5b461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5b461",
  null
  
)

export default component.exports